import React from 'react';
import GeneralDetail from './GeneralDetail';
import GeneralEdit from './GeneralEdit';
import { Tabs } from 'antd';
import Cancellation from '../Cancellation';
import CheckOutChargeDetail from '../CheckOutCharge/CheckOutChargeDetail';
import CheckOutChargeEdit from '../CheckOutCharge/CheckOutChargeEdit';
import CommissionDetail from '../Commission/CommissionDetail';
import CommissionEdit from '../Commission/CommissionEdit';
import Fees from './../Fees';
import PetsTable from '../Pets/PetsTable';
import GPTable from '../GuaranteePayment/GPTable';
import TaxesTable from '../Taxes/TaxesTable';
import OtherPolicies from './../OtherPolicies';
import ExtraCharge from '../ExtraCharge/Add_Edit'
import MinAndMaxStay from '../MinAndMaxStay/index';
import Rates from '../Rates/RatesTable'

const { TabPane } = Tabs;
const viewModel = 'view';
const editModel = 'edit';
const disableModelList = ['edit']
interface propsTypes {
    isEditable: void | any,
    cancelEditable: void | any,
    activeTabKey: string,
    changeTab: void | any,
    operationType: string,
    setOperationType: void | any,
    policiesData: void | any,
    getPoliciesData: void | any,
    setPoliciesData: void | any,
    setCancellationDetails: void | any,
    setFeesDetails: void | any,
    setPetsDetails: void | any,
    setOtherPoliciesDetails: void | any,
    setRatesDetails: (e:object) => void,
    petsAllowType: any,
    setPetsAllowType: void | any
}
const GeneralTab = (props: propsTypes) => {
    return (
        <Tabs defaultActiveKey={props.activeTabKey} onChange={props.changeTab}>
            <TabPane tab="General" key="General" disabled={disableModelList.includes(props.operationType)} >
                {props.operationType === viewModel && <GeneralDetail
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    setOperationType={props.setOperationType}
                    detailData={props.policiesData} />
                }
                {props.operationType === editModel && <GeneralEdit
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    setOperationType={props.setOperationType}
                    detailData={props.policiesData}
                    supplier={props.policiesData?.supplier}
                    propertyid={props.policiesData?.propertyId}
                    getPoliciesData={props.getPoliciesData}
                    setPoliciesData={props.setPoliciesData}
                    setPetsAllowType={props.setPetsAllowType}
                />}
            </TabPane>
            <TabPane tab="Cancellation" key="Cancellation" disabled={disableModelList.includes(props.operationType)}>
                <Cancellation
                    changeTab={props.changeTab}
                    setCancellationDetails={props.setCancellationDetails}
                    isEditable={props.isEditable}
                    detailData={props.policiesData}
                />
            </TabPane>
            <TabPane tab="Check-Out Charge" key="CheckOutCharge" disabled={disableModelList.includes(props.operationType)}>
                {props.operationType === viewModel && <CheckOutChargeDetail
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    setOperationType={props.setOperationType}
                    detailData={props.policiesData}
                    supplier={props.policiesData?.supplier}
                    propertyid={props.policiesData?.propertyId}
                    getPoliciesData={props.getPoliciesData}
                    setPoliciesData={props.setPoliciesData}
                />
                }
                {props.operationType === editModel &&
                    <CheckOutChargeEdit
                        isEditable={props.isEditable}
                        cancelEditable={props.cancelEditable}
                        setOperationType={props.setOperationType}
                        detailData={props.policiesData}
                        supplier={props.policiesData?.supplier}
                        propertyid={props.policiesData?.propertyId}
                        getPoliciesData={props.getPoliciesData}
                        setPoliciesData={props.setPoliciesData}
                    />
                }
            </TabPane>
            <TabPane tab="Commission" key="Commission" disabled={disableModelList.includes(props.operationType)}>
                {props.operationType === viewModel && <CommissionDetail
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    setOperationType={props.setOperationType}
                    detailData={props.policiesData}
                />}
                {props.operationType === editModel && <CommissionEdit
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    setOperationType={props.setOperationType}
                    detailData={props.policiesData}
                    supplier={props.policiesData?.supplier}
                    propertyid={props.policiesData?.propertyId}
                    getPoliciesData={props.getPoliciesData}
                    setPoliciesData={props.setPoliciesData}
                />}
            </TabPane>
            <TabPane tab="Extra Charge" key="Extra Charge" disabled={disableModelList.includes(props.operationType)}>
                <ExtraCharge
                    isEditable={props.isEditable}
                    setOperationType={props.setOperationType}
                    detailData={props.policiesData}
                />
            </TabPane>
            <TabPane tab="Fees" key="Fees" disabled={disableModelList.includes(props.operationType)}>
                <Fees
                    changeTab={props.changeTab}
                    setFeesDetails={props.setFeesDetails}
                    isEditable={props.isEditable}
                    detailData={props.policiesData}
                />
            </TabPane>
            <TabPane tab="Guarantee Payment" key="GuaranteePayment" disabled={disableModelList.includes(props.operationType)}>
                <GPTable changeTab={props.changeTab} setCancellationDetails={props.setCancellationDetails} isEditable={props.isEditable} detailData={props.policiesData} />
            </TabPane>
            <TabPane tab="Min/Max Stay" key="MinAndMaxStay" disabled={disableModelList.includes(props.operationType)}>
            <MinAndMaxStay
                isEditable={props.isEditable}
                cancelEditable={props.cancelEditable}
                setOperationType={props.setOperationType}
                detailData={props.policiesData}
                supplier={props.policiesData?.supplier}
                propertyid={props.policiesData?.propertyId}
                getPoliciesData={props.getPoliciesData}
                setPoliciesData={props.setPoliciesData}
                model={props.operationType}
            />
            </TabPane>
            {props?.policiesData?.policies?.general?.petsallowed === 'Pets Not Allowed' ?
                <TabPane tab="Pets" key="Pets" disabled={true}></TabPane>
                :
                <TabPane tab="Pets" key="Pets" disabled={disableModelList.includes(props.operationType)}>
                    <PetsTable
                        changeTab={props.changeTab}
                        setPetsDetails={props.setPetsDetails}
                        isEditable={props.isEditable}
                        detailData={props.policiesData}
                    />
                </TabPane>
            }

            <TabPane tab="Rates" key="Rates" disabled={disableModelList.includes(props.operationType)}>
                <Rates
                    changeTab={props.changeTab}
                    setOperationType={props.setOperationType}
                    setRatesDetails={props.setRatesDetails}
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    detailData={props.policiesData}
                />
            </TabPane>

            <TabPane tab="Taxes" key="Taxes" disabled={disableModelList.includes(props.operationType)}>
                <TaxesTable changeTab={props.changeTab} setCancellationDetails={props.setCancellationDetails} isEditable={props.isEditable} detailData={props.policiesData} />
            </TabPane>
            <TabPane tab="Other Policies" key="OtherPolicies" disabled={disableModelList.includes(props.operationType)}>
                <OtherPolicies
                    changeTab={props.changeTab}
                    setOtherPoliciesDetails={props.setOtherPoliciesDetails}
                    isEditable={props.isEditable}
                    detailData={props.policiesData}
                />
            </TabPane>
        </Tabs>
    )
}

export default GeneralTab;

